export enum EstadosCivil {
  SOLTERO = '1',
  SEPARADO = '2',
  VIUDO = '5'
}

